import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ScanLine, Lock, CheckCircle2 } from "lucide-react";
import { toast, Toaster } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("Les deux mots de passe ne correspondent pas");
      return;
    }
    if (password.length < 8) {
      toast.error("Le mot de passe doit faire au moins 8 caractères");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      toast.success("Mot de passe réinitialisé");
      setTimeout(() => nav("/login"), 1800);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Échec");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-gray-50" data-testid="reset-password-page">
      <Toaster richColors position="top-right" />
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 justify-center mb-6">
          <div className="w-8 h-8 bg-[#002FA7] flex items-center justify-center">
            <ScanLine className="text-white" size={18} />
          </div>
          <span className="font-heading font-black text-xl tracking-tighter">FACTURÉ</span>
        </div>

        <div className="ra-card p-6">
          <p className="overline mb-2">Réinitialisation</p>
          <h1 className="font-heading font-black text-3xl tracking-tighter mb-2">Nouveau mot de passe</h1>

          {!token ? (
            <div>
              <p className="text-sm text-red-600 mt-3">Lien invalide. Veuillez refaire une demande de réinitialisation.</p>
              <Link to="/login" className="btn-secondary mt-4">Retour</Link>
            </div>
          ) : done ? (
            <div className="mt-6 text-center">
              <CheckCircle2 size={48} className="text-green-500 mx-auto mb-2" />
              <p className="font-semibold">Mot de passe mis à jour</p>
              <p className="text-sm text-gray-500 mt-1">Redirection vers la connexion...</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4 mt-4">
              <div>
                <label className="ra-label"><Lock size={12} className="inline mr-1" />Nouveau mot de passe</label>
                <input
                  className="ra-input"
                  type="password"
                  required
                  minLength={8}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Au moins 8 caractères"
                  data-testid="reset-password-input"
                />
              </div>
              <div>
                <label className="ra-label">Confirmer</label>
                <input
                  className="ra-input"
                  type="password"
                  required
                  minLength={8}
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  data-testid="reset-confirm-input"
                />
              </div>
              <button type="submit" disabled={loading} className="btn-primary w-full justify-center py-3" data-testid="reset-submit-button">
                {loading ? "..." : "Réinitialiser"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
